module.exports = __webpack_public_path__ + "img/S500.5dc4f50f.jpg";